//@ts-check
import config from '../utils/config.js';
import {addField, allFulfilled, noop} from '../utils/utils.js';
import readCookie from '../utils/cookie.js';
import {dcl} from '../utils/windowEvents.js';
import getWixBiSession from '../utils/wixBiSession.js';

const entryType = 'wix-finish';

const FIELDS = [
    'microPop',
    'is_rollout',
    'is_platform_loaded',
    'maybeBot',
    'isjp'
];
const MAP_NAME = {
    is_rollout: 'isRollout',
    is_platform_loaded: 'isPlatformLoaded',
    isjp: 'maybeBot'
};

/**
 * Final Wix session attributes
 * @param {import('../utils/utils.js').State} state
 * @param {Promise} interactive
 */
export default function wixFinish([window], interactive) {
    const model = window.fetchDynamicModel || Promise.resolve({});
    return allFulfilled([getCDN(window), model, interactive, dcl(window)]).then(([cdn, {visitorId}]) => {
        const wixBiSession = getWixBiSession(window);
        if (!wixBiSession) {
            throw entryType;
        }

        const isSsr = !window.clientSideRender;
        const {btype} = wixBiSession;
        const bsi = readCookie(window, 'bSession');
        const result = {
            entryType,
            isSsr,
            isWelcome: !!window.requestCloseWelcomeScreen,
            ...cdn && {cdn},
            ...visitorId && {visitorId},
            ...btype && {btype},
            ...bsi && {bsi}
        };

        addField(result, 'pageId', window.rendererModel?.landingPageId || window.firstPageId);
        if (isSsr) {
            const {ssrInfo = {}} = window;
            addField(result, 'ssrDuration', ssrInfo.renderBodyTime || ssrInfo.timeSpentInSSR);
        }

        FIELDS.forEach(field => addField(result, MAP_NAME[field] || field, wixBiSession[field]));

        return result;
    });
}

function getCDN({URL}) {
    if (!URL) {
        return Promise.resolve();
    }
    const {origin} = new URL(config.src);
    return fetch(`${origin}/cdn_detect`, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache'
    })
        .then(response => response.headers.get('CDN-seen'))
        .catch(noop);
}
